import {HttpErrorResponse} from '@angular/common/http';

export class ErrorHelper {

  static disectError(prefix: string, someError): string {
    console.log('disectError:', prefix, someError);
    let message = someError;
    if (someError instanceof HttpErrorResponse) {
      const httpStatus = ` (${someError.status})`;
      if (someError.error instanceof Error) {
        message = someError.error.message + httpStatus;
      } else {
        const serverResponse = someError.error;
        if ('errorMessage' in serverResponse) {
          message = serverResponse.errorMessage + httpStatus;
        } else if ('message' in serverResponse) {
          message = serverResponse.message + httpStatus;
        } else if ('msg' in serverResponse) {
          message = serverResponse.msg + httpStatus;
        } else {
          message = serverResponse + httpStatus;
        }
      }
    } else {
      if (someError instanceof Error) {
        message = someError.message;
      }
    }
    if (prefix) {
      message = prefix + ':\n' + message;
    }
    return message;
  }

}

